import { Injectable } from '@angular/core';
import { firstTruthy } from '@shared/rxjs-operators';
import { catchError, EMPTY, ignoreElements, Observable, switchMap } from 'rxjs';
import { EventTrackerEventDto } from 'src/.api-client/models/event-tracker-event-dto';
import { EventTrackerApiService } from 'src/.api-client/services/event-tracker-api.service';
import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })
export class EventTrackerService {
    constructor(
        private readonly _eventTrackerApiService: EventTrackerApiService,
        private readonly _configService: ConfigService,
    ) {}

    public fireAndForgetEvent(eventTrackerEvent: EventTrackerEventDto, traceId: string): void {
        this._configService.configObs
            .pipe(
                firstTruthy(),
                switchMap((config) => {
                    if (!config.eventsTracked) {
                        return EMPTY;
                    }

                    return this.#sendEvent(eventTrackerEvent, traceId);
                }),
                ignoreElements(),
                catchError(() => EMPTY),
            )
            .subscribe();
    }

    #sendEvent(eventTrackerEvent: EventTrackerEventDto, traceId: string): Observable<void> {
        return this._eventTrackerApiService.eventTrackerSendEvent({ 'x-trace-id': traceId, body: eventTrackerEvent });
    }
}
